import { adminConsoleColors } from "Utils/global";
import styled from "styled-components";

export const MainContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  color: ${adminConsoleColors.commonGrayPocket};
  background-color: ${adminConsoleColors.white};
  border-radius: 10px;

  .pocketStudioModal{
    width: 45vw;
  }
`

export const ModalButtonContainer = styled.div`
  display: flex;
  column-gap: 10px;
`

export const ActionsContainer = styled.div`
  display: flex;
  column-gap: 10px;
  justify-content: center;
  align-items: center;
`

export const Icon = styled.i`
  cursor: pointer;
  color: ${({color}) => color};
` 

export const CenteredIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  column-gap: 10px;
  width: 100%;
  height: 100%;
`

export const BusinessListContainer = styled.div`
  padding: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 30px;

  #button_container {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
  }
`

export const BusinessNotFound = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  justify-content: center;
  align-items: center;
`

export const BusinessManagementContainer = styled.div`
  height: 100%;
  width: 100%;

  display: flex;
  flex-direction: column;
  row-gap: 10px;

  padding: 20px;

  h2 {
    color: ${adminConsoleColors.commonGrayPocket};
  }

  #header_container {
    display: flex;
    justify-content: space-between;
    align-items: center;

    margin: 0 0 5% 10%;
    
    #button_container {
      display: flex;
      column-gap: 10px;
    }
  }

  #business_infos {
    width: 100%;
    overflow: auto;

    display:flex;
    flex-direction: column;
    column-gap: 10px;

    .title_section{
      text-transform: capitalize;
      text-decoration: underline;
    }
  }

  section {
    width: 100%;
    overflow: auto;

    display:flex;
    justify-content: center;
    column-gap: 10px;
  }
`

export const SectionContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 5px;
  #business_informations_container {
    margin: 1rem;
  }
  .ag-theme-alpine {
    height: 300px !important;
    padding: 1rem;
  }
`

export const ToggleSection = styled.div`
  display: flex;
  flex-direction: column;

  margin: 1rem;
`

export const ToggleContainer = styled.div`
display: flex;
column-gap: 10px;
align-items: center;
height: 20%;
margin-bottom: 15px;
`